import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WarningBarService {
  hideWarningBarSubject: Subject<void> = new Subject<void>();
  checkWarningsSubject: Subject<void> = new Subject<void>();
  constructor(
  ) {
  }

  checkWarnings() {
    this.checkWarningsSubject.next();
  }

  hideWarningBar() {
    this.hideWarningBarSubject.next();
  }
}
